'use client';

import { type FC, useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { localeAtom } from '@core/Atoms/Locale/Locale.atom';
import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { currentVehicleIdAtom } from '@core/Atoms/Vehicle/CurrentVehicleId.atom';
import type { Locale } from '@core/Entities/Locale/Locale.entity';
import type { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import { addRecentlyViewed } from '@page-builder/Components/RecentlyViewed/AddRecentlyViewed';

type Props = {
  vehicle: Vehicle;
  locale: Locale;
};

export const PdpLogic: FC<Props> = ({ vehicle, locale }) => {
  const setCurrentVehicle = useSetAtom(currentVehicleAtom);
  const setCurrentVehicleId = useSetAtom(currentVehicleIdAtom);
  const setLocale = useSetAtom(localeAtom);

  useEffect(() => {
    setLocale(locale);
  }, [locale]);

  useEffect(() => {
    setCurrentVehicle(vehicle);
    setCurrentVehicleId(vehicle?.heycarId);

    addRecentlyViewed(vehicle?.heycarId, locale);
  }, [vehicle]);

  return null;
};

PdpLogic.displayName = 'PdpLogic';
